import React, { Fragment, useState, useEffect, useMemo } from "react";
import Breadcrumb from "../../layout/breadcrumb";
import { Container, Row, Col, Card, CardBody, Button } from "reactstrap";
import { getAllAdminWalletHistory, getWalletBalance } from "../../api";
import { MaterialReactTable } from "material-react-table";
import { Box } from "@mui/material";
import formatedDate from "../../utilities/formatedDate";
import convertToRupees from "../../utilities/convertToRupees";
import GetButtons from "../common/getButtons";
import GetExport from "../common/getExport";
import { ADMIN_HASH, ADMIN_WALLET_ID, paymentTypeOptionsForFilter } from "../../constant";

const AdminWalletHistory = () => {
  const [data, setData] = useState([]);
  const [count, setCount] = useState(0);
  const [adminWalletBalance, setAdminWalletBalance] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([{ "id": "brand_id", "desc": true }]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });



  const [adminWalletPayload, setAdminWalletPayload] = useState({
    hash: ADMIN_HASH,
    user_wallet_id: ADMIN_WALLET_ID,
  });

  useEffect(() => {
    getData(
      pagination.pageIndex,
      pagination.pageSize,
      globalFilter,
      columnFilters,
      sorting
    );
  }, [pagination.pageIndex, pagination.pageSize, globalFilter, columnFilters, sorting]);

  const getData = async (page, rowsPerPage, searchText, columnFilters, sorting) => {
    setIsLoading(true);
  
    try {
      const historyResponse = await getAllAdminWalletHistory(adminWalletPayload, page, rowsPerPage, searchText || "", columnFilters, sorting);
      const historyResult = historyResponse.data.result?.result;
      setData(historyResult);
      setCount(historyResponse.data.result?.totalCount);

  
      const balanceResponse = await getWalletBalance(adminWalletPayload);
      const balanceResult = balanceResponse.data.result;
      setAdminWalletBalance(balanceResult.balance);
    } catch (error) {
      // toast.error(error.response.data.error);
    } finally {
      setIsLoading(false);
    }
  };

 

  const refresh = () => {
    getData(
      pagination.pageIndex,
      pagination.pageSize,
      globalFilter,
      columnFilters,
      sorting
    );
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "createdAt",
        header: "Time",
        filter: false,
        enableClickToCopy: false,
        enableFilters: false,
        enableColumnFilter: false,
        size: 80,
        Cell: ({ row }) => <div>{formatedDate(row.original.adminHistory.createdAt)}</div>,
      },

      {
        // accessorKey: "adminHistory.user_wallet_history_id",
        accessorKey: "utrNo",
        header: "UTR/TXN",
        filter: false,
        enableClickToCopy: false,
        Cell: ({ row }) => (
          <div>{row.original.WalletTransaction?.utrNo}</div>
        ),
      },
      {
        accessorKey: "CTYPE",
        header: "Type",
        filter: false,
        filterVariant: 'select',
        enableClickToCopy: false,
        filterSelectOptions: paymentTypeOptionsForFilter,
        Cell: ({ row }) => {
          const modeMappings = {
            online: "Payment Gateway",
            offline: "EA Wallet",
            va_navision_dealer: "ECollection",
            va_navision_admin: "ECollection map",
            policy_refund: "Policy refund",
            wallet_refund: "Wallet refund",
            self_online: "Payment Gateway",
            refund_auto: "Refund Auto",
          };

          let mode = "N/A";

          if (row.original?.adminHistory?.CTYPE) {
            const CTYPE = row.original.adminHistory.CTYPE.toLowerCase();
            mode = modeMappings[CTYPE] || "N/A";
          }

          return <div>{mode}</div>;

          // return <div>{mode + ' '+ row.original.walletHistoryData.CTYPE}</div>;
        },
      },
      {
        accessorKey: "updated_amount",
        header: "Used",
        filter: false,
        enableClickToCopy: false,
        enableColumnFilter: false,
        // Cell: ({ row }) => (
        //   <div className="font-danger">
        //     {row.original?.TYPE === "SUB"
        //       ? convertToRupees(row.original?.updated_amount)
        //       : "-"}
        //   </div>
        // ),
        Cell: ({ row }) => (
          <div className='font-danger'>
            {row.original.adminHistory?.TYPE === 'SUB' ? (
              row.original.adminHistory?.updated_amount != null ? (
                convertToRupees(row.original.adminHistory?.updated_amount)
              ) : (
                '-'
              )
            ) : (
              '-'
            )}
          </div>
        ),
      },
      {
        accessorKey: "updated_amount",
        header: "Added",
        filter: false,
        enableClickToCopy: false,
        enableColumnFilter: false,
        // Cell: ({ row }) => (
        //   <div className="font-success">
        //     {row.original?.TYPE === "ADD"
        //       ? convertToRupees(row.original?.updated_amount)
        //       : "-"}
        //   </div>
        // ),
        Cell: ({ row }) => (
          <div className='font-success'>
            {row.original.adminHistory?.TYPE === 'ADD' ? (
              row.original.adminHistory?.updated_amount != null ? (
                convertToRupees(row.original.adminHistory?.updated_amount)
              ) : (
                '-'
              )
            ) : (
              '-'
            )}
          </div>
        ),
      },
      {
        accessorKey: "available_amount",
        header: "Balance",
        filter: false,
        enableClickToCopy: false,
        enableColumnFilter: false,
        Cell: ({ row }) => (
          <div>{convertToRupees(row.original.adminHistory.available_amount)}</div>
        ),
      },

      {
        accessorKey: "adminHistory.status",
        header: "Remark",
        filter: false,
        enableClickToCopy: false,
        enableColumnFilter: false,
      },
    ],
    []
  );


    const exportedData = data?.map((item) => ({
      Time: formatedDate(item.createdAt),
      Transaction: item.user_wallet_history_id,
      Mode: item.CTYPE,
      Used: item.updated_amount,
      Added: item.updated_amount,
      Balance: item.available_amount,
    }));

  

  return (
    <Fragment>
      <Breadcrumb parent="Navision" title="Admin Wallet" />
      <Container fluid={true}>
        <Row>
          <Col xl="9 xl-100" className="chart_data_left box-col-12">
            <Card>
              <CardBody className="p-0">
                <Row className="m-0 chart-main">

                  <>
                    <Col xl="4" md="4" sm="4" className="p-0 box-col-4">
                      <div className="media align-items-center p-3">
                        <div className="media-body">
                          <div className="right-chart-content">

                            <h5>
                              {isLoading ? (
                                'Loading....'
                              ) : (
                                convertToRupees(adminWalletBalance)
                              )}
                            </h5>

                            <span>{"Current Balance"} </span>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xl="4" md="4" sm="4" className="p-0 box-col-4">
                      <div className="media align-items-center p-3">
                        <div className="media-body">
                          <div className="right-chart-content">
                            <h5>
                              {isLoading ? (
                                'Loading....'
                              ) : (
                                count
                              )}
                            </h5>
                              <span>{"Transaction"}</span>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </>

                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <div>
        <MaterialReactTable
          columns={columns}
          data={data}
          initialState={{ showColumnFilters: false, density: "compact" }}
          enableGlobalFilter={false}
          manualFiltering
          manualPagination
          manualSorting
          onColumnFiltersChange={setColumnFilters}
          onGlobalFilterChange={setGlobalFilter}
          onPaginationChange={setPagination}
          onSortingChange={setSorting}
          defaultColumn={{
            maxSize: 400,
            minSize: 80,
            size: 150, //default size is usually 180
          }}
          // enableColumnResizing
          columnResizeMode="onChange" //default
          renderTopToolbarCustomActions={({ table }) => (
            <>
              <Box
                sx={{
                  display: "flex",
                  gap: "0.3rem",
                  p: "0.5rem",
                  flexWrap: "wrap",
                }}
              >
      
                <GetButtons onClick={refresh} type="refresh" />
                <GetExport columns={columns} exportedData={exportedData} name="Admin_Wallet" />
             
              </Box>
            </>
          )}
          rowCount={count}
          // rowCount={2000}
          state={{
            columnFilters,
            globalFilter,
            isLoading,
            pagination,
            sorting,
          }}
        />
      </div>
    </Fragment>
  );
};

export default AdminWalletHistory;
